export { default as StructuredData } from './src/structured-data';
export type { StructuredDataProps } from './@types/types';
